import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import {
    message,
    Card,
    Input,
    Button,
    Form,
    Modal,
    InputNumber,
    Spin,
    Row,
    Col,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class AccountSetting extends React.Component {
    state = {
        loading: false, // 是否加载中
        accountInfo: {}, // 账号信息
    };

    async componentDidMount () {
        this.fetchAccountInfo();
    }

    /**
     * 获取账号信息
     */
    fetchAccountInfo = async () => {
        this.setState({ loading: true });
        axios.get(`/v1/api/union_detail`).then((res) => {
            this.setState({
                loading: false,
                accountInfo: res.data || {},
            });
        });
    };

    /**
     * 保存
     */
    handleSave = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post("/v1/api/union_modify_info", {
                        desc: values.union_desc,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["saveSuccessMessage"]);
                            this.fetchAccountInfo();
                        }
                    });
            }
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.formRef.props.form.resetFields();
    };

    render () {
        return (
            <div className='p10' style={{ maxWidth: "600px" }}>
                <Card
                    title={
                        <h2>{this.props.language["accountInfo"]}</h2>
                    }
                    type="inner"
                >
                    <Spin spinning={this.state.loading}>
                        <AccountInfoForm
                            {...this.props}
                            accountInfo={this.state.accountInfo}
                            handleSave={this.handleSave}
                            handleReset={this.handleReset}
                            wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                        />
                    </Spin>
                </Card>
            </div>
        );
    }
}

/**
 * 账号设置表单
 */
const AccountInfoForm = Form.create({ name: "account_info_form" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Form>
                    <Form.Item
                        label={
                            Cookie.get("unionType") === "super_union"
                                ? this.props.language["superUnionId"]
                                : this.props.language["unionId"]
                        }
                    >
                        {getFieldDecorator("union_id", {
                            rules: [
                                {
                                    required: true,
                                    message:
                                        Cookie.get("unionType") === "super_union"
                                            ? this.props.language["superUnionIdVerify"]
                                            : this.props.language["unionIdVerify"],
                                },
                            ],
                            initialValue: this.props.accountInfo.union_id,
                        })(
                            <InputNumber
                                disabled
                                min={0}
                                max={100000000}
                                precision={0}
                                placeholder={
                                    Cookie.get("unionType") === "super_union"
                                        ? this.props.language["superUnionIdPlaceholder"]
                                        : this.props.language["unionIdPlaceholder"]
                                }
                            />
                        )}
                    </Form.Item>
                    <Form.Item
                        label={
                            Cookie.get("unionType") === "super_union"
                                ? this.props.language["superUnionName"]
                                : this.props.language["unionName"]
                        }
                    >
                        {getFieldDecorator("union_name", {
                            rules: [
                                {
                                    required: true,
                                    message:
                                        Cookie.get("unionType") === "super_union"
                                            ? this.props.language["superUnionNameVerify"]
                                            : this.props.language["unionNameVerify"],
                                },
                            ],
                            initialValue: this.props.accountInfo.union_name,
                        })(
                            <Input
                                maxLength={60}
                                disabled
                                allowClear
                                placeholder={
                                    Cookie.get("unionType") === "super_union"
                                        ? this.props.language["superUnionNamePlaceholder"]
                                        : this.props.language["unionNamePlaceholder"]
                                }
                            />
                        )}
                    </Form.Item>
                    <Form.Item label={this.props.language["gameId"]}>
                        {getFieldDecorator("user_id", {
                            rules: [
                                {
                                    required: true,
                                    message: this.props.language["gameIdVerify"],
                                },
                            ],
                            initialValue: this.props.accountInfo.user_id,
                        })(
                            <InputNumber
                                disabled
                                min={0}
                                max={100000000}
                                precision={0}
                                placeholder={this.props.language["gameIdPlaceholder"]}
                            />
                        )}
                    </Form.Item>
                    <Form.Item label={this.props.language["gameAccount"]}>
                        {getFieldDecorator("user_account", {
                            rules: [
                                {
                                    required: true,
                                    message: this.props.language["gameAccountVerify"],
                                },
                            ],
                            initialValue: this.props.accountInfo.user_account,
                        })(
                            <Input
                                maxLength={60}
                                disabled
                                allowClear
                                placeholder={this.props.language["gameAccountPlaceholder"]}
                            />
                        )}
                    </Form.Item>
                    <Form.Item
                        label={
                            Cookie.get("unionType") === "super_union"
                                ? this.props.language["superUnionIntroduce"]
                                : this.props.language["unionIntroduce"]
                        }
                    >
                        {getFieldDecorator("union_desc", {
                            rules: [
                                {
                                    required: false,
                                    message:
                                        Cookie.get("unionType") === "super_union"
                                            ? this.props.language["superUnionIntroduceVerify"]
                                            : this.props.language["unionIntroduceVerify"],
                                },
                            ],
                            initialValue: this.props.accountInfo.union_desc,
                        })(
                            <Input.TextArea
                                rows={5}
                                maxLength={120}
                                allowClear
                                placeholder={
                                    Cookie.get("unionType") === "super_union"
                                        ? this.props.language["superUnionIntroducePlaceholder"]
                                        : this.props.language["unionIntroducePlaceholder"]
                                }
                            />
                        )}
                    </Form.Item>
                    <Row type="flex" justify="end" align="middle">
                        <Col>
                            <Button className="mr10" onClick={this.props.handleReset}>
                                {this.props.language["reset"]}
                            </Button>
                        </Col>
                        <Col>
                            <Button type="primary" onClick={this.props.handleSave}>
                                {this.props.language["save"]}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            );
        }
    }
);
